export default __webpack_public_path__ + "static/media/w2.6c242f67.jpg";